// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__20bxc","selected":"Chip_selected__2oub4"};